@for (item of assemblyItems; track trackByAssemblyType($index, item); let isLast = $last) {
  <furniture-assembly-item class="block b-t p-t"
    [item]="item"
    [ngClass]="isLast ? 'p-b-2' : 'p-b-5'"
    >
  </furniture-assembly-item>
}